package com.eladfinish.bible.contest.screens.browse.tableOfContents.ui.menu

import androidx.compose.runtime.Composable
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.font_size_change
import com.eladfinish.bible.contest.help
import com.eladfinish.bible.contest.ic_arrow_folder_open
import com.eladfinish.bible.contest.ic_bookmark_check
import com.eladfinish.bible.contest.ic_format_size
import com.eladfinish.bible.contest.ic_help
import com.eladfinish.bible.contest.load_saved_completions
import com.eladfinish.bible.contest.open_bookmark
import com.eladfinish.bible.contest.ui.components.toolbar.SetToolbarConfiguration
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarActionConfig
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarActionPlacement
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarConfiguration
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarHeaderComponentConfig
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarIcon
import com.eladfinish.bible.contest.ui.components.toolbar.model.ToolbarKind
import com.eladfinish.bible.contest.ui.menus.actions.BrowseToolbarAction
import com.eladfinish.bible.contest.ui.menus.actions.ToolbarActionEmitter
import dev.icerock.moko.resources.compose.painterResource
import dev.icerock.moko.resources.desc.desc
import kotlinx.collections.immutable.toImmutableList

enum class BrowseToolbarId {
    HELP,
    CHANGE_FONT_SIZE,
    OPEN_BOOKMARK,
    LOAD_SAVED_COMPLETIONS,
}

@Composable
internal fun BrowseMenu(
    title: String,
    toolbarEmitter: ToolbarActionEmitter<BrowseToolbarAction>,
    isCompleteChapter: Boolean,
) {
    val placement = if (isCompleteChapter) ToolbarActionPlacement.InOverflow else ToolbarActionPlacement.OnToolbar
    SetToolbarConfiguration(
        configuration = ToolbarConfiguration(
            kind = ToolbarKind.Browse,
            title = ToolbarHeaderComponentConfig.Text(text = title),
            actions = listOfNotNull(
                ToolbarActionConfig.IconAction(
                    id = BrowseToolbarId.OPEN_BOOKMARK,
                    icon = ToolbarIcon.PainterIcon(
                        painter = painterResource(imageResource = SharedRes.images.ic_bookmark_check)
                    ),
                    menuText = SharedRes.strings.open_bookmark.desc(),
                    onClick = {
                        toolbarEmitter.emit(BrowseToolbarAction.OpenBookmark)
                    },
                    placement = ToolbarActionPlacement.OnToolbar,
                ).takeUnless { isCompleteChapter },
                ToolbarActionConfig.IconAction(
                    id = BrowseToolbarId.LOAD_SAVED_COMPLETIONS,
                    icon = ToolbarIcon.PainterIcon(
                        painter = painterResource(imageResource = SharedRes.images.ic_arrow_folder_open)
                    ),
                    menuText = SharedRes.strings.load_saved_completions.desc(),
                    onClick = {
                        toolbarEmitter.emit(BrowseToolbarAction.LoadSavedCompletions)
                    },
                    placement = ToolbarActionPlacement.OnToolbar,
                ).takeIf { isCompleteChapter },
                ToolbarActionConfig.IconAction(
                    id = BrowseToolbarId.CHANGE_FONT_SIZE,
                    icon = ToolbarIcon.PainterIcon(
                        painter = painterResource(imageResource = SharedRes.images.ic_format_size)
                    ),
                    menuText = SharedRes.strings.font_size_change.desc(),
                    onClick = {
                        toolbarEmitter.emit(BrowseToolbarAction.ChangeFontSize)
                    },
                    placement = placement,
                ),
                ToolbarActionConfig.IconAction(
                    id = BrowseToolbarId.HELP,
                    icon = ToolbarIcon.PainterIcon(
                        painter = painterResource(imageResource = SharedRes.images.ic_help)
                    ),
                    menuText = SharedRes.strings.help.desc(),
                    onClick = {
                        toolbarEmitter.emit(BrowseToolbarAction.Help)
                    },
                    placement = placement,
                ),
            ).toImmutableList()
        )
    )
}
